import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

import { images, healthWorkerIcons } from "../../../../constants/icons";

const aggregateMonthlyData = (data, selectedYear) => {
  const monthlyData = Array.from({ length: 12 }, (_, i) => ({
    month: new Date(0, i).toLocaleString("default", { month: "short" }), // Jan, Feb, Mar...
    ongoing: 0,
    completed: 0,
  }));

  data.forEach(({ date, ongoing, completed }) => {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const monthIndex = dateObj.getMonth();

    if (year === selectedYear) {
      monthlyData[monthIndex].ongoing += ongoing;
      monthlyData[monthIndex].completed += completed;
    }
  });

  return monthlyData;
};

const getAvailableYears = (data) => {
  const years = new Set(data.map(({ date }) => new Date(date).getFullYear()));
  return [...years].sort((a, b) => b - a);
};

const ConsultationHealthWorker = ({ chartData }) => {
  const availableYears = getAvailableYears(chartData);
  const [selectedYear, setSelectedYear] = useState(availableYears[0]); 

  const filteredData = aggregateMonthlyData(chartData, selectedYear);

  return (
    <div className="sm:block w-auto h-[400px] rounded-lg bg-white p-[20px]">
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <p className="text-base font-bold">Consultation - {selectedYear}</p>
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-600">Filter by Year:</span>
            <select
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              value={selectedYear}
              className="px-3 py-1 bg-blue-500 text-white rounded-md text-xs"
            >
              {availableYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-between w-[40%] text-[10px] text-textgray mt-2">
          <p className="flex w-18 justify-between">
            <span className="pr-1">
              <img src={healthWorkerIcons.yellowIndiIcon} alt="" />
            </span>{" "}
            Ongoing Contracts
          </p>
          <p className="flex w-18 justify-between">
            <span className="pr-1">
              <img src={healthWorkerIcons.greenIndiIcon} alt="" />
            </span>{" "}
            Completed Contracts
          </p>
        </div>
      </div>
      <ResponsiveContainer>
        <LineChart data={filteredData} margin={{ top: 10, right: 30, left: 0, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="ongoing" stroke="#FFD700" strokeWidth={2} />
          <Line type="monotone" dataKey="completed" stroke="#45f248" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ConsultationHealthWorker;
